import serverApi from './serverAPIConfig'

export default {
    ...serverApi,
    continuousSave: false
}
